/* Ourcade theme behaviours: mobile nav, gallery thumbs, grid columns, sort, sticky buy bar. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Campaign reference: remember ?oc_ref= from a marketing link (30 days) and carry it into the order
     as a cart attribute (oc_ref) and a hidden line item property (_oc_ref, survives Buy it now). */
  (function () {
    var KEY = 'oc-ref', PARAM = 'oc_ref', MAX_AGE = 30 * 24 * 60 * 60 * 1000;
    var ref = null;
    try {
      var fromUrl = new URLSearchParams(window.location.search).get(PARAM);
      if (fromUrl) fromUrl = fromUrl.trim().slice(0, 200);
      if (fromUrl) {
        ref = fromUrl;
        localStorage.setItem(KEY, JSON.stringify({ v: ref, t: Date.now() }));
      } else {
        var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (saved && saved.v && Date.now() - saved.t < MAX_AGE) ref = saved.v;
        else if (saved) localStorage.removeItem(KEY);
      }
    } catch (e) { /* storage unavailable: fall through with whatever the URL gave us */ }
    if (!ref) return;

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes[PARAM] === ref) return;
        var attributes = {};
        attributes[PARAM] = ref;
        return fetch(updateUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () { /* non-critical */ });

    var tagForm = function (form) {
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var input = form.querySelector('input[name="properties[_' + PARAM + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_' + PARAM + ']';
        form.appendChild(input);
      }
      input.value = ref;
    };
    document.querySelectorAll('form[action*="/cart/add"]').forEach(tagForm);
    document.addEventListener('submit', function (e) { tagForm(e.target); }, true);

    /* Red Bank Rumble only: show the visitor's personalised image as the main product image.
       The default stays in place if the custom image fails to load. */
    if (/\/products\/red-bank-rumble\/?$/.test(window.location.pathname)) {
      var main = document.querySelector('[data-oc-gallery] [data-oc-media]:first-child img');
      if (main) {
        var src = 'https://custom.ourcade.com/' + encodeURIComponent(ref) + '.png';
        var probe = new Image();
        probe.onload = function () {
          var swap = function (img) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.width = probe.naturalWidth;
            img.height = probe.naturalHeight;
            img.src = src;
          };
          swap(main);
          var thumb = document.querySelector('[data-oc-gallery] [data-oc-thumb] img');
          if (thumb) swap(thumb);
        };
        probe.src = src;
      }
    }
  })();

  /* Mobile navigation dialog */
  document.querySelectorAll('[data-oc-nav-open]').forEach(function (btn) {
    var dialog = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dialog) return;
    btn.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
    });
    dialog.addEventListener('close', function () {
      btn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      btn.focus();
    });
    dialog.querySelectorAll('[data-oc-nav-close]').forEach(function (c) {
      c.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-oc-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-oc-stage]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-oc-thumb]'));
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-oc-media]'));
    if (!stage || !thumbs.length) return;
    var setCurrent = function (i) {
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (items[i]) {
          stage.scrollTo({ left: items[i].offsetLeft - stage.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        setCurrent(i);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) setCurrent(items.indexOf(en.target));
        });
      }, { root: stage, threshold: [0.6] });
      items.forEach(function (it) { io.observe(it); });
    }
  });

  /* Hero slider: scroll-snap track, auto-advance with pause, seamless loop via a cloned first slide */
  document.querySelectorAll('[data-oc-slider]').forEach(function (root) {
    var track = root.querySelector('[data-oc-slider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-oc-slider-dot]'));
    var toggle = root.querySelector('[data-oc-slider-toggle]');
    var caption = root.querySelector('[data-oc-slider-caption]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var index = 0, timer = null, settle = null, hovering = false, visible = true;
    var userPaused = reduceMotion || root.getAttribute('data-autoplay') === 'false';

    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('tabindex', '-1');
    var cloneImg = clone.querySelector('img');
    if (cloneImg) { cloneImg.removeAttribute('fetchpriority'); cloneImg.setAttribute('alt', ''); }
    track.appendChild(clone);

    function setActive(i) {
      index = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (caption) caption.textContent = slides[i].getAttribute('data-caption') || '';
    }
    function go(i, smooth) {
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (userPaused || hovering || !visible || document.hidden) return;
      timer = setInterval(function () { go(index + 1, true); }, interval);
    }
    function renderToggle() {
      if (!toggle) return;
      toggle.setAttribute('data-state', userPaused ? 'paused' : 'playing');
      toggle.setAttribute('aria-label', toggle.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
      track.setAttribute('aria-live', userPaused ? 'polite' : 'off');
    }

    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i >= count) { track.scrollTo({ left: 0, behavior: 'auto' }); i = 0; }
        setActive(i);
      }, 120);
    }, { passive: true });

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n, true); play(); }); });
    if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; renderToggle(); play(); });
    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; play(); });
    root.addEventListener('focusin', function () { hovering = true; stop(); });
    root.addEventListener('focusout', function () { hovering = false; play(); });
    document.addEventListener('visibilitychange', play);
    window.addEventListener('resize', function () { go(index, false); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; play(); }, { threshold: 0.25 }).observe(root);
    }
    renderToggle();
    play();
  });

  /* Collection column toggle */
  document.querySelectorAll('[data-oc-cols]').forEach(function (wrap) {
    var grid = document.getElementById(wrap.getAttribute('data-oc-cols'));
    if (!grid) return;
    var btns = Array.prototype.slice.call(wrap.querySelectorAll('button'));
    var apply = function (n, persist) {
      grid.setAttribute('data-cols', n);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.value === n ? 'true' : 'false'); });
      if (persist) { try { localStorage.setItem('oc-cols', n); } catch (e) { /* storage unavailable */ } }
    };
    var saved = null;
    try { saved = localStorage.getItem('oc-cols'); } catch (e) { /* storage unavailable */ }
    if (saved === '2' || saved === '3') apply(saved, false);
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.value, true); }); });
  });

  /* Sort select submits its form */
  document.querySelectorAll('[data-oc-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (!sel.form) return;
      if (sel.form.requestSubmit) sel.form.requestSubmit(); else sel.form.submit();
    });
  });

  /* Line total next to the add-to-cart label */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var f = format || '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: out = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  document.querySelectorAll('[data-oc-line-total]').forEach(function (el) {
    var form = el.closest('form');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    var priceCents = parseInt(el.getAttribute('data-price-cents'), 10);
    var fmt = el.getAttribute('data-money-format');
    if (!qty || isNaN(priceCents)) return;
    var update = function () {
      var q = parseInt(qty.value, 10);
      if (!q || q < 1) q = 1;
      el.textContent = formatMoney(priceCents * q, fmt);
    };
    qty.addEventListener('change', update);
    qty.addEventListener('input', update);
  });

  /* Mobile sticky buy bar: scroll to the personaliser until the form is unlocked, then submit it */
  document.querySelectorAll('[data-oc-sticky-buy]').forEach(function (bar) {
    var form = document.getElementById(bar.getAttribute('data-oc-sticky-buy'));
    var btn = bar.querySelector('button');
    var target = document.getElementById(bar.getAttribute('data-oc-scroll-target') || '');
    if (!form || !btn) return;
    var labelStart = bar.getAttribute('data-label-start') || '';
    var labelReady = bar.getAttribute('data-label-ready') || '';
    var update = function () {
      var hidden = form.offsetParent === null || getComputedStyle(form).display === 'none';
      var start = hidden && !!target;
      bar.setAttribute('data-state', start ? 'start' : 'ready');
      btn.textContent = start ? labelStart : labelReady;
      btn.disabled = !start && hidden;
    };
    update();
    if ('MutationObserver' in window) {
      new MutationObserver(update).observe(form, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    btn.addEventListener('click', function () {
      if (bar.getAttribute('data-state') === 'ready') {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      } else if (target) {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var first = target.querySelector('input, button, [tabindex]');
        if (first) first.focus({ preventScroll: true });
      }
    });
  });
})();
